import React, { useState } from "react";
import {
  Typography,
  Grid,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@mui/material";
import { MdInfo, MdClose } from "react-icons/md";
import { useTranslation } from "next-i18next"; // Importar useTranslation
import CurrencyFormatter from "../currency-formatter";

interface InfoButtonModalProps {
  notaryExpenses: number;
  registryExpenses: number;
  taxesExpenses: number;
  totalExpenses: number;
}

const InfoButtonModal: React.FC<InfoButtonModalProps> = ({
  notaryExpenses,
  registryExpenses,
  taxesExpenses,
  totalExpenses,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const { t } = useTranslation(); // Usar useTranslation

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <>
      <IconButton color="primary" size="small" onClick={handleOpenModal}>
        <MdInfo />
      </IconButton>
      <Dialog open={openModal} onClose={handleCloseModal}>
        <DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleCloseModal}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <MdClose />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ paddingBottom: 6 }}>
          <Grid
            sx={{ padding: 1, paddingBottom: 1, paddingLeft: 3 }}
            container
            spacing={0}
          >
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Typography fontWeight="700" fontSize="1.2rem" paddingBottom={3}>
                {t("mortgage_calculator.expenses_tooltip")}
              </Typography>
            </Grid>
            <Grid item xs={6} sm={6} md={4} lg={5}>
              <Typography fontWeight="600" fontSize="1.1rem" gutterBottom>
                {t("mortgage_calculator.notary_expenses")}:
              </Typography>
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={7}>
              <Typography fontWeight="600" fontSize="1.1rem" gutterBottom>
                {CurrencyFormatter(notaryExpenses)}
              </Typography>
            </Grid>
            <Grid item xs={6} sm={6} md={4} lg={5}>
              <Typography fontWeight="600" fontSize="1.1rem" gutterBottom>
                {t("mortgage_calculator.registry_expenses")}
              </Typography>
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={7}>
              <Typography fontWeight="600" fontSize="1.1rem" gutterBottom>
                {CurrencyFormatter(registryExpenses)}
              </Typography>
            </Grid>
            <Grid item xs={6} sm={6} md={4} lg={5}>
              <Typography fontWeight="600" fontSize="1.1rem" gutterBottom>
                {t("mortgage_calculator.taxes_expenses")}
              </Typography>
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={7}>
              <Typography fontWeight="600" fontSize="1.1rem" gutterBottom>
                {CurrencyFormatter(taxesExpenses)}
              </Typography>
            </Grid>
          </Grid>
          <Divider />
          <Grid
            sx={{ padding: 2, paddingBottom: 1, paddingLeft: 3 }}
            container
            spacing={0}
          >
            <Grid item xs={6} sm={6} md={4} lg={5}>
              <Typography fontWeight="800" fontSize="1.1rem" gutterBottom>
                {t("mortgage_calculator.total_expenses")}
              </Typography>
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={7}>
              <Typography fontWeight="800" fontSize="1.1rem" gutterBottom>
                {CurrencyFormatter(totalExpenses)}
              </Typography>
            </Grid>
          </Grid>
          <Divider />
          <Typography
            fontWeight="600"
            fontSize="0.9rem"
            sx={{ padding: 2, paddingLeft: 3 }}
          >
            {t("mortgage_calculator.note")}
          </Typography>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default InfoButtonModal;
